module.exports = __webpack_public_path__ + "img/pdf-thumb.b54f43d8.jpg";